import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Notification } from '../../../components/SavedSearches/MobileComponents/Notification';
import { selectSavedSearchesNotification } from '../../../selectors/savedSearches/selectSavedSearchesNotification';
import { setSavedSearchesNotificationVisible } from '../../../actions/savedSearchesNotification';

export function NotificationsContainer() {
  const isVisible = useSelector(selectSavedSearchesNotification);
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (!isVisible) {
      return;
    }

    const timer = setTimeout(() => {
      dispatch(setSavedSearchesNotificationVisible({ visible: false }));
    }, 3000);

    return () => clearTimeout(timer);
  }, [isVisible, dispatch]);

  if (!isVisible) {
    return null;
  }

  return <Notification />;
}
